import classNames from 'clsx';
import PropTypes from 'prop-types';
import FavoriteIcon from './controls/favorite/FavoriteIcon';
import { FavoriteIconControl } from './controls/favorite/FavoriteIconControl';
import css from './controls/favorite/favorite-control-with-options.module.scss';

export function FavoriteOption({
  guideItem,
  followActionOrOption,
  className,
  iconClassName,
  unFavoritedClassName,
}) {
  return (
    <FavoriteIconControl
      guideItem={guideItem}
      followActionOrOption={followActionOrOption}
      isOption
      iconClassName={iconClassName}
      unFavoritedClassName={unFavoritedClassName}
    >
      {(props) => (
        <div
          data-testid={`follow-option-${props.guideId}`}
          className={classNames(css.row, className)}
        >
          <p>{props.isFavoritedLabel}</p>
          <div>
            <FavoriteIcon {...props} />
          </div>
        </div>
      )}
    </FavoriteIconControl>
  );
}

FavoriteOption.propTypes = {
  guideItem: PropTypes.object,
  followActionOrOption: PropTypes.object,
  className: PropTypes.string,
};
